import { createSlice } from "@reduxjs/toolkit";
import { donateCartsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const donateCartSlice = createSlice({
  name: "donateCart",
  initialState: data,
  reducers: {
    donateCartSlice(state) {
      state.isLoading = true;
    },
    donateCartSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    donateCartSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    donateCartSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const donateCartHandler = (donation_id?:string) => async (dispatch: any) => {
  try {
    dispatch(donateCartAction.donateCartSlice());
    const response:any = await donateCartsAPI(donation_id);
    typeof localStorage !== "undefined" && localStorage.setItem('donation_count', response?.donation_count);
    
    dispatch(donateCartAction.donateCartSliceSuccess(response));
  } catch (e: any) {
    dispatch(donateCartAction.donateCartSliceFailure(e?.response?.data?.message));
    dispatch(donateCartAction.donateCartSliceReset());
  }
};
export default donateCartSlice.reducer;
export const donateCartAction = donateCartSlice.actions;
